import Vue from 'vue'

const mutations = {
    changeChatWindowStatus(state, payload) {
        state.chatWindowStatus = payload;
    },
    actionMessage(state, payload) {
        state.messages.push({
            sender: payload.sender,
            created_at: new Date(),
            text: payload.text
        });
    },
    changeWaitingList(state, payload) {
        state.waitingList = payload
    },
    setHasNewMessages(state, value) {
        state.hasNewMessages = value;
    },
    changeWritting(state, value, role) {
        state[role].isWritting = value;
    },
    setLastId(state, value) {
        state.lastId = value;
    },
    setWsState(state, value) {
        state.isWsActive = value;
    },
    cleanMessages(state) {
        state.messages = [];
        state.printedMessages = {};
    },
    updateThread(state, newThreadData) {
        state.thread = newThreadData;
    },
    addMessages(state, messages) {

        if (messages.length > 0) {

            for (var idx in messages) {
                if (!state.printedMessages[messages[idx].message_id]) {
                    state.hasNewMessages = true;
                    state.messages = state.messages.concat(messages[idx]);
                    state.printedMessages[messages[idx].message_id] = true;
                }

            }

            //state.messages = state.messages.concat(messages);

        }

    },
    setActiveVideocall(state, videocall) {
        state.activeVideocall = videocall
    },
    setId(state, id) {

        state.id = id;

    },
    setCloseChatTime(state, closeTime) {
        state.closeChatTime = closeTime;
    },
    setOperators(state, operators) {
        state.operators = operators;
    },
    setGroupId(state, groupId) {
        state.groupId = groupId
    },
    setOperator(state, operator) {
        state.operator = operator;
    },
    setToken(state, token) {
        state.token = token;
    },
    setLoading(state, loading) {
        state.showLoading = loading;
    },
    setLanguage(state, language) {
        state.language = language;
    },
    setClient(state, client) {
        if (client) {
            state.user.name = client.name;
            state.user.email = client.email;
        }
    },
    clearClient(state) {
        state.user.name = null;
        state.user.email = null;
    },
    setCartInfo(state, cart_info) {
        if (cart_info) {
            state.cartInfo.token = cart_info.token;
            state.cartInfo.share_url = cart_info.share_url;
            state.cartInfo.quantity_items = cart_info.quantity_items;
        }
    },
    clearCartInfo(state) {
        //{"token":"13PS4TC8XJYYO0gSDOUY","share_url":"http:\/\/islas4dev-es.deswebislas.com:8080\/mallorca\/en\/ChatCart\/13PS4TC8XJYYO0gSDOUY","quantity_items":3}
        state.cartInfo.token = null;
        state.cartInfo.share_url = null;
        state.cartInfo.quantity_items = 0;
    },
    setAgent(state, agent) {
        if (agent) {
            state.agent.name = agent.name;
            state.agent.avatar = agent.avatar;
        }
    },
    setChatTypes(state, payload) {
        if (payload) {
            state.chatTypes = payload;
            state.chatType = 0;
        }
    },
    setChatType(state, type) {
        state.chatType = type;
    },
    setDefaultResponses(state, payload) {
        if (payload) {
            state.defaultResponses = payload;
        }
    },
    setAppointmentUrls(state, payload) {
        if (payload) {
            state.appointmentUrls = payload;
        }
    },
    setIncidentInteractions(state, payload) {
        if (payload) {
            state.incidentInteractions = payload;
        }
    },
    chatRated(state, rated) {
        state.chat_rated = rated;
    },
    setBanned(state, {banned, till}) {
        state.isBanned = banned;
        if(till)
            state.bannedTill = till;
    },
    closeChat(state) {
        state.id = null;
        state.token = null;
        state.lastId = 0;
        state.messages = [];
        state.printedMessages = {};
        state.hasNewMessages = false;
        state.chat_rated = false;
        state.contact_phone = null;
        state.opening_hour = null;
        state.closing_hour = null;
    },
    setLocale(state, lang) {
        state.language = lang;
        Vue.config.language = document.documentElement.lang;
    },
    setHideIncidentInteractions(state, hide) {
        state.hide_incident_interactions = hide;
    },
    setPolicyUrl(state, url) {
        state.policy_url = url;
    },
    setDataProtectionUrl(state, url) {
        state.data_protection_url = url;
    },
    setThreadState(state, thread_state) {
        state.thread_state = thread_state;
    },
    changeBounce(state, value) {
        state.bounce = value
    },
    messagesSeen(state) {
        state.hasNewMessages = false;
    },
    changeHasBounced(state, value) {
        state.hasBounced = value;
    },
    setBounceDuration(state, duration) {
        state.bounce_duration = duration;
    },
    setBounceStart(state, start) {
        state.bounce_start = start;
    },
    setChatOpen(state, value) {
        state.isChatOpened = value
    },
    updateDrag(state, value) {
        state.dragActive = value
    },
    updateCall(state, value) {
        state.call = value;
    },
    showCallForm(state, value) {
        state.callForm = value;
    },
    setAudioInput(state, value) {
        state.audioInput = value;
    },
    setAudioOutput(state, value) {
        state.audioOutput = value;
    },
    setGroupsWithCamera(state, value) {
        state.groupsWithCamera = value;
    },
    setSelectedGroupGotCamera(state, value) {
        state.selectedGroupGotCamera = value;
    },
    setOperatorGotCameraActive(state, value) {
        state.operatorGotCameraActive = value;
    },
    setConfig(state, config) {
        state.config = config;
    },
    setQueuePosition(state, queuePosition) {
        state.queue_position = queuePosition
    },
    setWaitingTime(state, waitingTime) {
        state.waiting_time = waitingTime
    },
    setCloseByInactivity(state, closeByInactivity) {
        state.closeByInactivity = closeByInactivity
    },
    setChatWindowOpen(state, value) {
        state.isChatWindowOpen = value
    },
    setPhonePrefix(state, value) {
        state.phone_prefix = value;
    },
    setGreetingText(state, value) {
        state.greetingText = value;
    },
    setAgentTyping(state, value){
        state.agent.isTyping = value;
    },
    setUserTyping(state, value){
        state.user.isTyping = value;
    },
    setPulseCXUrl(state, url) {
        state.pulseCXUrl = url;
    },
    setContactPhone(state, phone) {
        state.contact_phone = phone;
    },
    setOpeningHours(state, hour) {
        state.opening_hour = hour;
    },
    setClosingHours(state, hour) {
        state.closing_hour = hour;
    },
    setChatAvailability(state, available) {
        state.isChatAvailable = available;
    },
    setVideoChatAvailability(state, available) {
        state.isVideoChatAvailable = available;
    },
    /**
     * Sets or clears the access-blocked banner message.
     *
     * Pass a string to show the banner; pass null to hide it.
     * Called by handleIPError() when the backend returns a 403,
     * and reset to null at the start of every new chat attempt.
     *
     * @param {Object} state - Vuex state
     * @param {string|null} message - Error message to display, or null to clear
     */
    setAccessBlockedMessage(state, message) {
        state.accessBlockedMessage = message;
    },
};

export default mutations